import {AbstractDTO} from "@signature-it/ngx-generic/models";

export class SolrConditionDTO extends AbstractDTO {

    key: string;
    value: string;

    constructor(attributes: Object) {
        super(attributes);
        attributes = attributes || {};

        this.key = attributes['key'] || '';
        this.value = attributes['value'] || '';
    }
}

export class CarouselDTO extends AbstractDTO {

    name: string;
    subTitle: string;
    solrField: string;
    solrCondition: Array<SolrConditionDTO>;
    rows: number;
    alias: string;
    order: number;
    location: Array<string>;
    localstorage_key: string;
    showInProductPage: boolean;
    showInCatalogue: boolean;
    previewTemplateVar: string;

    constructor(attributes: Object) {
        super(attributes);
        attributes = attributes || {};

        this.name = attributes['name'] || '';
        this.subTitle = attributes['subTitle'] || '';
        this.solrField = attributes['solr_field'] || '';
        this.rows = attributes['rows'] || 1;
        this.alias = attributes['alias'] || '';
        this.order = attributes['order'] || 0;
        this.solrCondition = attributes['solrCondition'] ? SolrConditionDTO.createFromArray(attributes['solrCondition']) : [];
        this.location = attributes['location'] || ['product-page'];
        this.localstorage_key = attributes['localstorage_key'] || '';
        this.showInProductPage = this.location.indexOf('product-page') > -1;
        this.showInCatalogue = this.location.indexOf('catalogue') > -1;
        this.previewTemplateVar = attributes['previewTemplateVar'] || '';
    }
}

